// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__9rFIn","containerItemsCenter":"Skeleton_containerItemsCenter__bltDf"};